<script>
import findIndex from 'lodash/findIndex';
import vueMixins from 'viralstyle-ui/src/vueMixins';
import { mapState } from 'vuex';

import BuyerCheckbox from './BuyerCheckbox';

export default {
  components: {
    BuyerCheckbox,
  },
  mixins: [vueMixins],
  props: {
    selectedProductType: String,
    productTypes: Array,
    categories: Object,
  },
  data: () => ({
    showAll: false,
  }),
  computed: {
    selectedProductTypeIndex() {
      let index = findIndex(this.productTypes, productType => productType.id == this.selectedProductType);

      return index + 1 > 5 ? index + 1 : 5;
    },
    displayedProductTypes() {
      if (this.productTypes.length - this.selectedProductTypeIndex === 0) {
        this.showAll = true;
      }

      return this.showAll ? this.productTypes : this.productTypes.slice(0, this.selectedProductTypeIndex);
    },
  },
  methods: {
    handleSelectProductType(value) {
      if (this.selectedProductType !== value) {
        this.$emit('update-state', { property: 'selectedProductType', value: `${value}` });

        this.$emit('get-campaigns');
      }
    },
  },
};
</script>

<template lang='pug'>
.pt-1(v-show='productTypes.length', :class='{ "border-t border-brand-secondary-75": categories }')
  .font-bold.tracking-widest.text-lg.md_text-sm TYPE
  buyer-checkbox.text-brand-secondary-850.cursor-pointer.hover_underline.mt-_75(
    v-for='productType in displayedProductTypes',
    :small='$mq === "sm" || $mq === "md" ? false : true',
    :key='productType.id',
    :label='productType.name',
    :model='selectedProductType == productType.id',
    :value='true',
    @input='handleSelectProductType(productType.id)'
  )
  .text-sm.text-brand-secondary-400.mt-1.ml-1_75.cursor-pointer.hover_underline.inline-block(
    v-show='productTypes.length - selectedProductTypeIndex > 0',
    tabindex='0',
    @click='showAll = !showAll',
    @keyup.enter='showAll = !showAll',
  )
    span(v-if='showAll') Less
    span(v-else) +{{productTypes.length - selectedProductTypeIndex}} More
</template>